import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=4e79ea5e&scoped=true"
import script from "./AccountModal.vue?vue&type=script&lang=js"
export * from "./AccountModal.vue?vue&type=script&lang=js"
import style0 from "./AccountModal.vue?vue&type=style&index=0&id=4e79ea5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e79ea5e",
  null
  
)

export default component.exports